<template>
  <div class="tree-box">
    <div class="tree-box-tree">
      <ul>
        <li class="admin-list-tree-title">部门</li>
        <el-button
          link
          title="刷新"
          size="small"
          :class="state.departmentData ? '' : 'refresh-rotate'"
          @click="onLoadDepartment"
        >
          <template #icon>
            <el-icon style="font-weight: 600" color="#a2a2a2" :size="16"
              ><Refresh
            /></el-icon>
          </template>
        </el-button>
      </ul>
      <div style="flex: 1; overflow: auto; padding-right: 10px">
        <el-tree
          :data="[{ name: '左才右财薪酬管理系统', children: state.departmentData }]"
          node-key="id"
          :props="{ label: 'name', children: 'children' }"
          default-expand-all
          :expand-on-click-node="false"
          style="width: fit-content"
          @node-click="onDepartmentClick"
        />
      </div>
    </div>
    <div class="tree-box-content">
      <ul class="tree-box-content-search">
        <el-space wrap style="flex: 1">
          <el-input
            v-model="state.params.name"
            style="width: 200px"
            placeholder="--关键字--"
            clearable
            @clear="
              delete state.params.name;
              onLoad();
            "
          ></el-input>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </ul>
      <div class="tree-box-content-table">
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
        >
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            label="选择"
            prop="status"
            sortable="status"
            width="100"
            align="center"
          >
            <template #default="{ row }">
              <el-checkbox
                v-model="row.checked"
                :key="state.key"
                @change="onChange($event, row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            sortable="name"
            label="姓名"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            min-width="120"
          />
          <el-table-column
            prop="phone"
            label="手机号"
            :formatter="$tab_TextFormat"
            min-width="120"
          />

          <el-table-column
            prop="department_name"
            label="所属部门"
            :formatter="$tab_TextFormat"
            min-width="120"
          />
          <el-table-column
            prop="email"
            label="邮箱"
            :formatter="$tab_TextFormat"
            min-width="120"
          />
          <el-table-column
            prop="job"
            label="职务"
            :formatter="$tab_TextFormat"
            min-width="120"
          />
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { role_bind } from "@/http/adminrole";
import { data_department_tree, data_admin_page } from "@/http/data";
import { ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadDepartment();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      data_admin_page(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list.map((m) => {
            return {
              ...m,
              checked: m.admin_role_id?.split(",")?.some((s) => s == props.id),
            };
          });
          state.totalCount = count;
          state.key = Math.random();
        }
      });
    };

    const onLoadDepartment = () => {
      delete state.departmentData;
      data_department_tree({ limit: 0 }).then((res) => {
        if (res.status == 200) state.departmentData = res.data.data;
      });
    };

    const onDepartmentClick = (row) => {
      state.params.department_id = row.id;
      state.params.page = 1;
      onLoad();
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onChange = (checked, item) => {
      const data = { id: props.id, admin_id: item.id, checked };
      role_bind(data).then((res) => {
        if (res.status == 200) {
          ElMessage({
            message: res.data.msg,
            showClose: true,
            dangerouslyUseHTMLString: true,
            type: "success",
          });
          state.key = Math.random();
        } else {
          item.checked = !item.checked;
        }
      });
    };

    return {
      state,
      onLoadDepartment,
      onLoad,
      onSortChange,
      onDepartmentClick,
      onReset,
      props,
      onChange,
    };
  },
};
</script>
<style scoped lang="less">
.admin-list-tree-title {
  position: relative;
  padding-left: 7px;
  font-size: 13px;
  color: #a2a2a2;
  flex: 1;
  &::after {
    content: "";
    width: 3px;
    background-color: #1e90ff;
    border-radius: 10px;
    height: 70%;
    top: 15%;
    position: absolute;
    left: 0;
  }
}

.refresh-rotate {
  animation: fadenum 2s linear infinite;
}

@keyframes fadenum {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
